import { Component, inject, OnInit } from '@angular/core';
import { ChatService } from '@lcms/shared/mt-bot';

@Component({
  selector: 'app-messenger-drawer',
  templateUrl: './messenger-drawer.component.html',
})
export class MessengerDrawerComponent implements OnInit {
  chatService = inject(ChatService);

  ngOnInit(): void {}

  switchAction(action: string) {
    this.chatService.currentAction.next(action);
    console.log(action);
    if (action === 'conversation') {
      this.chatService.conv_id.next(null);
      this.chatService.send_convId.next(null);
    }
  }
}
